/**
 * Copyright Mántum All Rights Reserved.
 */
import debug from 'debug';
import fetcher from './fetcher';
import useSWR from 'swr';
import { validator } from '@mantum/kanela';
import DataTable, {
    Column,
    FilterRow,
    LoadPanel,
    Selection
} from 'devextreme-react/data-grid';

import type { Columns, DataSource } from '@mantum/kanela';
import type dxDataGrid from 'devextreme/ui/data_grid';
import type { EventInfo } from 'devextreme/events';

const logger = debug('kanela:datagrid:detail');

export type PropTypes = {
    allowFiltering?: boolean;
    columns?: Columns;
    dataSource?: DataSource | unknown[] | string;
    enabled?: boolean;
    onClick?: (e: EventInfo<dxDataGrid<unknown, unknown>>) => void;
    selected?: Record<string, unknown>;
    selection?: 'none' | 'single' | 'multiple';
};

export default function Detail(props: PropTypes) {
    const {
        allowFiltering = false,
        columns = [],
        dataSource = [],
        selection = 'none'
    } = props;

    const query =
        !Array.isArray(dataSource) &&
        typeof dataSource !== 'string' &&
        !validator.isUndefined(dataSource.url)
            ? {
                  url: dataSource.url,
                  args: {
                      body: dataSource.parameter,
                      headers: dataSource.headers,
                      method: dataSource.method,
                      namespace: dataSource.namespace
                  }
              }
            : null;

    const { data: values } = useSWR(query, fetcher, {});
    const items = !Array.isArray(dataSource) ? values : dataSource;

    logger('render detail');
    return (
        <DataTable
            allowColumnReordering={true}
            allowColumnResizing={true}
            cacheEnabled={true}
            columnAutoWidth={true}
            dataSource={items}
            onSelectionChanged={props.onClick}
            showBorders={true}
            width='100%'
        >
            <LoadPanel enabled={true} />
            <FilterRow visible={allowFiltering} />
            <Selection mode={selection} showCheckBoxesMode='always' />

            {columns.map((row) => (
                <Column
                    key={row.name}
                    caption={row.label}
                    dataField={row.name}
                    dataType={
                        row.type !== 'select' &&
                        row.type !== 'email' &&
                        row.type !== 'link'
                            ? row.type
                            : 'string'
                    }
                    visible={row.visible}
                />
            ))}
        </DataTable>
    );
}
